<template>
  <div class="buy">
    <a-form
      :form="form"
      @submit="handleToPay"
    >
      <div class="buy_list">
        <div class="buy_item">
          <p class="item_title buy_first">
            {{ $t('message["475"]') }}：
          </p>
          <div class="item_main item_input_clear">
            <price-item
              v-if="originalPrice"
              :price="originalPrice"
              :content="priceItemTit"
            />
          </div>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["1458"]') }}：
          </p>
          <div class="item_main buy_input item_input_clear">
            <h2 class="total_num">
              {{ serviceInfo.user_limit }}{{ $t('message["929"]') }}
            </h2>
          </div>
        </div>
        <div class="buy_item">
          <a-form-item class="buy_input">
            <p class="item_title">
              {{ $t('message["264"]') }}：
            </p>
            <div class="item_main">
              <a-input-number
                v-decorator="[
                  'num',
                  {initialValue: payData.person}
                ]"
                class="input_num"
                :min="MIN_LIMIT_NUM"
                :max="maxUserLimit"
                @change="changeNumber"
              />
              <span class="num_suffx">{{ isEnglish ? '' : $t('message["929"]') }}</span>
            </div>
          </a-form-item>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["310"]') }}：
          </p>
          <div class="item_main item_main2 buy_input item_input_clear">
            <div class="term_tag">
              <span>{{ timestampToFormat(serviceInfo.fromtime) }}～{{ timestampToFormat(serviceInfo.totimenew, 2) }}</span>
            </div>
          </div>
        </div>
        <div class="buy_item">
          <p class="item_title">
            {{ $t('message["1595"]') }}：
          </p>
          <div class="item_main buy_input item_input_clear clearfix">
            <h2 class="total_price fl">
              {{ payData.price }}{{ $t('message["1523"]') }}
            </h2>
            <div
              v-if="priceDiff > 0"
              class="price-diff-con"
            >
              <span class="origin-price">{{ orignalTotal }} {{ $t('message["1523"]') }}</span>
              <em>（{{ disacountTips[0] }}{{ priceDiff }} {{ disacountTips[1] }}）</em>
            </div>
          </div>
        </div>
        <div
          class="buy_item"
          style="margin-top: 10px;"
        >
          <div class="item_main">
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["603"]') }}
            </a-button>
          </div>
        </div>
      </div>
      <!-- 支付提交 -->
      <form
        v-if="isShowForm"
        :id="formId"
        method="post"
        :action="posturl"
      >
        <input
          v-for="(value, key) in keyDatas"
          :key="key"
          :name="key"
          type="hidden"
          :value="value"
        >
      </form>
    </a-form>
  </div>
</template>

<script type="text/ecmascript-6">
import PriceItem from './components/PriceItem'
import { mapActions, mapState } from 'vuex'
import { getFixed, isNumber, timestampToFormat } from './common'
import { getLang } from '@/lib/storage'
import i18n from '@/lib/language'

// const EXPATION_TITLE = this.$t('message["579"]')
// const RENEWAL_TITLE = this.$t('message["1409"]')
const CRUMB_TITLE = i18n.t('message["579"]')

const MAX_LIMIT_NUM = 1000
const MIN_LIMIT_NUM = 1
const PRICE = 440

export default {
  components: {
    PriceItem
  },
  data () {
    return {
      MIN_LIMIT_NUM,
      MAX_LIMIT_NUM,
      form: this.$form.createForm(this),
      payData: {
        person: 1,
        price: 440,
        originalprice: 0
      },
      formId: Math.random().toString(10).substring(2),
      formDatas: {},
      isShowForm: true,
      orignalTotal: 0,
      endDate: ''
    }
  },
  computed: {
    ...mapState('config/service', ['serviceInfo']),
    posturl () {
      return this.formDatas.posturl
    },
    keyDatas () {
      return this.formDatas.data
    },
    type () {
      return this.$route.query.type
    },
    originalPrice () {
      return getFixed(this.payData.originalprice)
    },
    maxUserLimit () {
      return MAX_LIMIT_NUM - this.serviceInfo.user_limit
    },
    priceDiff () {
      const { orignalTotal, payData } = this
      return (orignalTotal - payData.price)
    },
    priceItemTit () {
      return this.$t('message["468"]')
    },
    disacountTips () {
      return this.$t('message["1476"]').split('|')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
    // beginDate () {
    //   if (this.serviceInfo.totimenew === 0) {
    //     return getDateTime(new Date(), 0)
    //   } else {
    //     return getDateTime(this.serviceInfo.totimenew, 0)
    //   }
    // }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setCrumbLabel(CRUMB_TITLE)
    })
  },
  created () {
    // if (this.serviceInfo.totimenew === 0) {
    //   this.endDate = getDateTime(new Date(), 1, 2)
    // } else {
    //   this.endDate = getDateTime(this.serviceInfo.totimenew, 1, 2)
    // }
    this.initPrice()
  },
  methods: {
    ...mapActions('config/service', ['getCountPrice', 'pay', 'setCrumbLabel']),
    timestampToFormat,
    getLang,
    initPrice () {
      let data = {
        num: this.payData.person,
        price: PRICE,
        type: this.type
      }
      this.getPrice(data)
    },
    // 提交支付
    handleToPay (e) {
      e.preventDefault()
      const _this = this
      _this.form.validateFields((err, values) => {
        if (!err) {
          _this.toPay()
        }
      })
    },
    changeNumber (value) {
      let number = isNumber(value) ? value : MIN_LIMIT_NUM
      let data = {}
      if (number > this.maxUserLimit) {
        data = this.setFormFieldsValue('num', this.maxUserLimit)
      } else {
        data = this.setFormFieldsValue('num', number)
      }
      this.getPrice(data)
    },
    async getPrice (data) {
      let userLimit = data.num
      const chain = await this.getCountPrice(data)
      chain.onSuccess(res => {
        const { discountprice, originalprice } = res
        this.payData.price = discountprice
        this.payData.originalprice = originalprice / userLimit
        this.orignalTotal = originalprice
      })
        .fetch()
    },
    async toPay () {
      let data = Object.assign({ num: this.form.getFieldValue('num') || MIN_LIMIT_NUM },
        { type: this.type },
        { price: PRICE },
        { money: this.payData.price })
      // console.log(data)
      const chain = await this.pay()
      chain.params(data)
        .onSuccess((res, allRes) => {
          if (!res.error && !(res.hasOwnProperty('redirect'))) {
            this.isShowForm = true
            this.formDatas = res
            setTimeout(() => {
              document.getElementById(this.formId).submit()
              this.isShowForm = false
            }, 1000)
          }
        })
        .fetch()
    },
    setFormFieldsValue (field, number) {
      this.form.setFieldsValue({ [field]: number })
      let data = Object.assign(this.form.getFieldsValue(), { price: PRICE }, { type: this.type })
      return data
    },
    setpayData (field, value) {
      let formData = this.form.getFieldsValue()
      for (let key in formData) {
        if (Object.prototype.toString.call(formData[key]) !== '[object Number]' || isNaN(formData[key])) {
          // console.log(key)
          this.form.setFieldsValue({ [key]: value })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.buy {
  width: 100%;
  background: #fff;
  border-top: 1px solid #ebebeb;
  .buy_list {
    margin: 30px 0 16px;
    .buy_item:first-of-type {
      height: 88px;
    }
    .buy_item {
      position: relative;
      height: 56px;
      .item_title {
        width: 84px;
        font-size:14px;
        color:#666;
        line-height:24px;
      }
      .item_input_clear {
        top: 50%;
        transform: translateY(-50%);
      }
      .item_main {
        position: relative;
        top: 0;
        left: 85px;
        button {
          background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
          box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
          border-radius:4px;
          border:1px solid rgba(80,119,170,1);
        }
        button:hover {
          background:linear-gradient(360deg,rgba(96,143,204,1) 0%,rgba(80,119,170,1) 100%);
        }
        .total_price {
          font-size: 24px;
          line-height: 56px;
          color: #5077AA;
          font-weight: 600;
          margin-top: -14px;
        }
        .term_tag {
          width: 320px;
          height: 32px;
          background: #ebebeb;
          border-radius: 4px;
          border: 1px solid #d6d6d6;
          span {
            line-height: 32px;
            color: #666;
            margin: 0 12px;
          }
        }
        .total_num {
          margin-top: -13px;
        }
        .input_num {
          position: absolute;
          top: -28px;
          width: 320px !important;
        }
        .num_suffx {
          position: relative;
          left: 270px;
          top: -28px;
          z-index: 100
        }
      }
      .item_main2 {
        top: -10px;
      }
    }
     .price-diff-con {
      float: left;
      margin-left: 6px;
      line-height: 30px;
      span{
        text-decoration:line-through;
        color: #b3b3b3;
      }
      em {
        color: #F6A953;
        font-style: normal;
      }
    }
  }
}
</style>
